/*
  ORIGIN COMICS — note de la communauté sur les cartes produit
  Chaque carte a un emplacement <p data-oc-card-rating="ID du produit">. Ce fichier va chercher la note
  (les critiques de la communauté) et l'affiche : « ★★★★★ 4,8 · 12 critiques » ou « Pas encore noté · sois le premier ».
  Les notes sont gardées 10 minutes dans le navigateur pour ne pas les redemander à chaque page.
  Fonctionne aussi quand la liste se recharge (filtres, tri, pages suivantes).
*/
const BASE = '/apps/communaute';
const STORE_KEY = 'oc-card-ratings-v1';
const KEEP_FOR = 10 * 60 * 1000;

let saved = {};
try {
  const raw = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
  if (raw.t && Date.now() - raw.t < KEEP_FOR) saved = raw.d || {};
} catch (e) {
  saved = {};
}

function keep() {
  try {
    sessionStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), d: saved }));
  } catch (e) {
    /* navigation privée : on ne garde rien, ce n'est pas grave */
  }
}

function esc(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}

function stars(note) {
  const full = Math.round(note || 0);
  let out = '';
  for (let i = 1; i <= 5; i++) out += i <= full ? '★' : '☆';
  return out;
}

const waiting = {};

function loadSummary(id) {
  if (Object.prototype.hasOwnProperty.call(saved, id)) return Promise.resolve(saved[id]);
  if (!waiting[id]) {
    waiting[id] = fetch(`${BASE}/works/${id}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
      .then((data) => {
        const s = data && data.summary;
        saved[id] = s && s.count ? { average: s.average, count: s.count } : { count: 0 };
        keep();
        return saved[id];
      })
      .catch(() => undefined);
  }
  return waiting[id];
}

function show(el, summary) {
  if (!summary) return; // l'application ne répond pas : on laisse la ligne vide
  if (summary.count) {
    const note = Math.round(summary.average * 10) / 10;
    el.innerHTML = `<b>${stars(summary.average)}</b> ${String(note).replace('.', ',')} · ${summary.count} critique${summary.count > 1 ? 's' : ''}`;
  } else {
    el.innerHTML = `Pas encore noté<span class="oc-card__rating-cta"> · <a href="${esc(el.dataset.url)}#critiques">sois le premier</a></span>`;
  }
  el.classList.add('is-ready');
}

function fill(root) {
  const list = [];
  if (root.matches && root.matches('[data-oc-card-rating]')) list.push(root);
  if (root.querySelectorAll) list.push(...root.querySelectorAll('[data-oc-card-rating]'));
  list.forEach((el) => {
    if (el.classList.contains('is-ready') || el.dataset.ocAsked) return;
    el.dataset.ocAsked = '1';
    loadSummary(el.dataset.ocCardRating).then((summary) => {
      delete el.dataset.ocAsked;
      show(el, summary);
    });
  });
}

fill(document);

new MutationObserver((changes) => {
  changes.forEach((change) => change.addedNodes.forEach((node) => node.nodeType === 1 && fill(node)));
}).observe(document.documentElement, { childList: true, subtree: true });
